<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">扫码收款</div>
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
	  </div>
    </div>
    <div class="success-wapper">
		<p>
			<span>+</span>{{money}}
		</p>
		{{type}}收款成功
	</div>
	<div class="btn-wapper">
		<router-link :to="'/user/collection/Scan'">
			<div class="collection-btn">返回继续扫码收款</div>
		</router-link>
	</div>
  </div>
</template>
<script>
import { postScanCollection, postCreateQrcode } from "@api/order";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";
import {  parseQuery } from "@utils";
import { wechatEvevt } from "@libs/wechat";
import Vue from "vue";
import cookie from "@utils/store/cookie";

 
const NAME = "Collection_success";

export default {
  name: NAME,
  data() {
    return {
	  type: '',
	  money: this.$route.query.money
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        
      }
    }
  },
  mounted() {
	  if(this.$route.query.type == 'weixin'){
		  this.type = '微信'
	  }
	  if(this.$route.query.type == 'alipay'){
	  	  this.type = '支付宝'
	  }
  },
  methods: {
	
  }
};
</script>

<style scoped>
.success-wapper p{
	margin-top: 1.5rem;
	font-size: 0.7rem;
	font-weight: bold;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #e93323;
}
.success-wapper{
	text-align: center;
	color: #666;
}
.success-wapper span{
	margin-bottom: 0.1rem;
}
.btn-wapper{
	padding: 0.2rem 0;
	margin: 0 auto;
	display: flex;
	justify-content: space-around;
	align-items: center;
	margin-top: 1rem;
}
.collection-btn{
	border-radius: 5px;
	padding: 0.2rem 0.7rem;
	color: #fff;
	background-color: #e93323;
}
</style>
